export default {
  tag: "Reservar una Sesión",
  title1: "Mantengamos Tu",
  title2: "Food Truck en Regla",
  subtitle: "Programa una consulta en el sitio de 1 hora con nuestro gerente de proyecto en el Condado de Orange",
  features: [
    { title: "Sesión de Consulta de 1 Hora", desc: "Sin compromiso — solo respuestas y un camino claro a seguir." },
    { title: "Orientación Específica del Condado de Orange", desc: "Nuestros expertos conocen cada ciudad y oficina del condado de Orange." },
    { title: "Programación Rápida", desc: "Normalmente confirmamos las citas dentro de 24 horas." },
    { title: "Enfoque Personalizado", desc: "Cada consulta se adapta a tu concepto específico de food truck." },
  ],
  imageCaption1: "Listos cuando tú lo estés.",
  imageCaption2: "Tiempo de respuesta promedio: menos de 24 horas",
  successTitle: "¡Consulta Solicitada!",
  successText: "Recibimos tu solicitud y nos comunicaremos dentro de 24 horas para confirmar tu cita.",
  submitAnother: "Enviar otra solicitud",
  formTitle: "Reserva Tu Sesión Gratuita",
  formSubtitle: "Completa el formulario a continuación y nos pondremos en contacto contigo en breve.",
  firstName: "Nombre *",
  lastName: "Apellido *",
  businessName: "Nombre del Negocio *",
  roleLabel: "Tu Rol / Cargo *",
  rolePlaceholder: "Selecciona tu rol...",
  roleOptions: ["Propietario / Fundador", "Copropietario", "Gerente de Operaciones", "Socio Comercial", "Inversionista", "Otro"],
  emailLabel: "Correo Electrónico *",
  truckStatusLabel: "Estado del Camión",
  truckPlaceholder: "Selecciona tu situación actual...",
  truckTypes: [
    "Aún no tengo uno",
    "Camión existente — necesita permisos",
    "Construcción de camión nuevo",
    "Convertir un vehículo",
    "Expandir a múltiples camiones",
  ],
  servicesLabel: "Servicios de Interés",
  servicesOptions: [
    "Asistencia con Permisos",
    "Desarrollo del Menú de Comida",
    "Certificación de Manipuladores de Alimentos",
    "Remodelación del Camión",
    "Cumplimiento Regulatorio",
    "Construcción y Equipamiento del Camión",
  ],
  preferredDate: "Fecha / Hora Preferida",
  conceptLabel: "Cuéntanos Sobre Tu Concepto",
  conceptPlaceholder: "Describe tu concepto de food truck, desafíos actuales o cualquier pregunta específica...",
  submitting: "Enviando...",
  bookSession: "Reservar una Sesión",
  noSpam: "Sin spam, nunca. Tu información se mantiene completamente privada.",
  errorTooLong: "El mensaje debe tener 500 caracteres o menos.",
  errorGeneric: "Algo salió mal. Por favor, inténtalo de nuevo.",
  errorNetwork: "Error de red. Verifica tu conexión e inténtalo de nuevo.",
};